module.exports = __webpack_public_path__ + "static/media/触摸感应模块.293a346f.png";